import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type WorkspaceMenuItem = "planning" | "portfolioIntelligence" | "commercialSimulator" | "scenarios" | "insights";

export interface WorkspaceState {
    selectedMenuItem: WorkspaceMenuItem;
}

const initialState: WorkspaceState = {
    selectedMenuItem: "planning"
};

const workspaceSlice = createSlice({
    name: "workspace",
    initialState,
    reducers: {
        setSelectedMenuItem: (state, action: PayloadAction<WorkspaceMenuItem>) => {
            state.selectedMenuItem = action.payload;
        }
    }
});

export const { setSelectedMenuItem } = workspaceSlice.actions;

export default workspaceSlice.reducer;
